export type DealsView = 'schools' | 'all';

type DealsViewToggleProps = {
  view: DealsView;
  onChange: (view: DealsView) => void;
};

// Two joined half-pills with a 1px gap. The active tab is #57578D (no Tailwind
// token) with a blueGray border; the inactive tab is primary-off.
const TABS: { value: DealsView; label: string; rounding: string }[] = [
  { value: 'schools', label: 'For Schools', rounding: 'rounded-l-full' },
  { value: 'all', label: 'For Everyone', rounding: 'rounded-r-full' },
];

export const DealsViewToggle = ({ view, onChange }: DealsViewToggleProps) => (
  <div role='group' aria-label='Deal categories' className='flex w-full gap-px'>
    {TABS.map(({ value, label, rounding }) => (
      <button
        key={value}
        type='button'
        aria-pressed={view === value}
        onClick={() => onChange(value)}
        className={`flex-1 px-5 py-2 font-openSans text-sm font-semibold leading-[1.7] text-offWhite transition-colors ${rounding} ${
          view === value ? 'border border-blueGray bg-[#57578D]' : 'bg-primary-off hover:opacity-90'
        }`}
      >
        {label}
      </button>
    ))}
  </div>
);
